<div class="relative mb-12 w-full">
    <img
        width="500"
        height="500"
        class="h-64 w-full object-cover lg:h-auto"
        ngSrc="/assets/images/simple-header-background.webp"
        priority
        alt="header-background"
    />
    <div class="absolute inset-0 flex items-center justify-center">
        <h1 class="lg:text-display-large text-display-small text-center text-white">
            {{ headerBlock().translations_refs | getTranslation: "title" }}
        </h1>
    </div>
</div>
